import {EuiModalFooter} from '@elastic/eui'
import {ReactNode} from 'react'

type Props = {
    children :ReactNode
}

const ComponentEuiModalFooter = ({ children } :Props) => <EuiModalFooter>{ children }</EuiModalFooter>

export default ComponentEuiModalFooter